module.exports = __webpack_public_path__ + "media/images/atterra-1-671b6625ce0063d272254bf022f515f0.jpg";